import { LANGUAGE } from 'constants/common';

export const getLangNameByCode = (code: string): string => {
  if (!code) return '';
  for (const key in LANGUAGE) {
    if (LANGUAGE[key].code === code) {
      return LANGUAGE[key].name;
    }
  }
  return '';
};

export const getShortNameByCode = (code: string): string => {
  if (!code) return '';
  for (const key in LANGUAGE) {
    if (LANGUAGE[key].code === code) {
      return LANGUAGE[key].shortName;
    }
  }
  return '';
};

export function formatPrice(num: number) {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
}
